import i18n from '@/lang/index.js';

export const AGENT_VALIDATION_STATUS_NOT_VERIFIED = 'not_verified';
export const AGENT_VALIDATION_STATUS_VALIDATION_IN_PROGRESS = 'validation_in_progress';
export const AGENT_VALIDATION_STATUS_VERIFIED = 'verified';
export const AGENT_VALIDATION_STATUS_REFUSED = 'refused';

export function useAgentValidationStatusList() {

  const messages = i18n.global.messages[i18n.global.locale];
  return [
    { key : AGENT_VALIDATION_STATUS_NOT_VERIFIED, value : messages.agentValidation.not_verified, color : 'blue-300' },
    { key : AGENT_VALIDATION_STATUS_VALIDATION_IN_PROGRESS, value : messages.agentValidation.validation_in_progress, color : 'yellow' },
    { key : AGENT_VALIDATION_STATUS_VERIFIED, value : messages.agentValidation.verified, color : 'green' },
    { key : AGENT_VALIDATION_STATUS_REFUSED, value : messages.agentValidation.refused, color : 'red' }
  ];
}
